import * as React from 'react';

export type FieldOption = { value: string; label: string; disabled: boolean; group?: string };

function textOf(node: React.ReactNode): string {
  return React.Children.toArray(node).map(child => React.isValidElement<{ children?: React.ReactNode }>(child) ? textOf(child.props.children) : String(child)).join('');
}

export function optionsOf(children: React.ReactNode, group?: string, disabled = false): FieldOption[] {
  return React.Children.toArray(children).flatMap(child => {
    if (!React.isValidElement<{ children?: React.ReactNode; value?: string | number; label?: string; disabled?: boolean; hidden?: boolean }>(child)) return [];
    if (child.type === 'option') {
      const label = child.props.label ?? textOf(child.props.children);
      return child.props.hidden ? [] : [{ value: String(child.props.value ?? textOf(child.props.children)), label, disabled: disabled || !!child.props.disabled, group }];
    }
    return optionsOf(child.props.children, child.type === 'optgroup' ? child.props.label : group, disabled || !!child.props.disabled);
  });
}

export function groupOptions(options: FieldOption[]) {
  const groups: { label?: string; options: FieldOption[] }[] = [];
  for (const option of options) {
    if (!groups.length || groups.at(-1)!.label !== option.group) groups.push({ label: option.group, options: [] });
    groups.at(-1)!.options.push(option);
  }
  return groups;
}
